const CATEGORY_COLORS = {
  "Blog Yazıları": "#00A2AB",
  "Makale": "#4D6B8A",
  "Haberler": "#E67E22",
  "Bültenler": "#2BA88F",
  "Kitap İncelemesi": "#7B61FF",
};

export const categoryColor = (category) => CATEGORY_COLORS[category] || "#00A2AB";

export const categoryStyle = (category) => ({
  color: categoryColor(category),
  background: "#ffffff",
});
